import api from './api';

const trackingLinkService = {
  getAll: async () => {
    const response = await api.get('/tracking-links');
    return response.data.tracking_links || [];
  },

  getAllForBot: async (botId) => {
    const response = await api.get(`/bots/${botId}/tracking-links`);
    return response.data.tracking_links || [];
  },

  create: async (botId, data) => {
    const response = await api.post(`/bots/${botId}/tracking-links`, data);
    return response.data.tracking_link;
  },

  update: async (id, data) => {
    const response = await api.put(`/tracking-links/${id}`, data);
    return response.data.tracking_link;
  },

  delete: async (id) => {
    const response = await api.delete(`/tracking-links/${id}`);
    return response.data;
  },

  getStatistics: async (id) => {
    const response = await api.get(`/tracking-links/${id}/statistics`);
    return response.data.statistics;
  },
};

export default trackingLinkService;
